import React, { Component } from 'react';
import PropTypes from 'prop-types';

import 'react-select/dist/react-select.css';

// import 'node_modules/react-select/dist/react-select.css';
// import '../../../../../node_modules/react-select/dist/ react-select/dist/react-select.css';

import '../styles/icon-select.css';

class IconOption extends Component {
  handleMouseDown = event => {
    event.preventDefault();
    event.stopPropagation();
    this.props.onSelect(this.props.option, event);
  };

  handleMouseEnter = event => {
    this.props.onFocus(this.props.option, event);
  };

  handleMouseMove = event => {
    if (this.props.isFocused) return;
    this.props.onFocus(this.props.option, event);
  };

  render = () => {

    return (
      <div
        className={`select-icon-option ${this.props.className}`}
        onMouseDown={this.handleMouseDown}
        onMouseEnter={this.handleMouseEnter}
        onMouseMove={this.handleMouseMove}
        title={this.props.option.name}
      >
        {this.props.option.icon && <img className="select-icon-option__img" alt="icon" src={this.props.option.icon} />}
        {this.props.option.name && this.props.option.name !== this.props.children && <span className="select-icon-option__title">{this.props.option.name}</span>}

        {this.props.option.description ? (
          <div>
            {this.props.children}
            <span className="select-icon-option__description"> {this.props.option.description} </span>
          </div>
        ) : (
          this.props.children
        )}
      </div>
    );
  };
}

IconOption.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  isDisabled: PropTypes.bool,
  isFocused: PropTypes.bool,
  isSelected: PropTypes.bool,
  onFocus: PropTypes.func,
  onSelect: PropTypes.func,
  option: PropTypes.object.isRequired,
};

class IconValue extends Component {
  render = () => {
    return (
      <div className="Select-value select-icon-value" title={this.props.value.name}>
        <div className="Select-value-label">
          {this.props.value.icon && <img className="select-icon-value__img" alt="icon" src={this.props.value.icon} />}
          {this.props.value.description ? (
            <div>
              {this.props.children}
              <span className="select-icon-value__description">{this.props.value.description} </span>
            </div>
          ) : (
            this.props.children
          )}
        </div>
      </div>
    );
  };
}

IconValue.propTypes = {
  children: PropTypes.node,
  value: PropTypes.object,
};

export { IconOption, IconValue };



// WEBPACK FOOTER //
// ./src/app/shared/custom-select/components/icon-select.jsx